import React from 'react';
import './waba-requirements-card.scss';

interface WabaRequirementsCard {
  icon: string;
  heading: string;
  description: string;
}

export const WabaRequirementsCard: React.FC<WabaRequirementsCard> = ({
  icon,
  heading,
  description,
}) => {
  return (
    <div className="waba-requirements-card">
      <div className="waba-requirements-card-left">
        <img src={icon} alt="" className="waba-requirements-card-left-icon" />
      </div>
      <div className="waba-requirements-card-right">
        <span className="waba-requirements-card-right-heading primary-font-semibold">
          {heading}
        </span>
        <span className="waba-requirements-card-right-description primary-font-regular">
          {description}
        </span>
      </div>
    </div>
  );
};
